var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01164 15.6818V10.9897H4.31893C4.05736 10.9894 3.80727 10.8853 3.62231 10.7003C3.43735 10.5153 3.3336 10.2645 3.33325 10.0029C3.3336 9.74132 3.43735 9.49055 3.62231 9.30556C3.80727 9.12058 4.05736 9.01648 4.31893 9.01613H9.01164V4.32469C9.01164 4.06279 9.11572 3.81173 9.3007 3.62634C9.48568 3.44096 9.73675 3.33647 9.99862 3.33594C10.2606 3.33647 10.5115 3.44082 10.6965 3.62634C10.8815 3.81187 10.9858 4.06332 10.9856 4.32534V9.01678H15.6796C15.9412 9.01714 16.1913 9.12123 16.3762 9.30621C16.5612 9.4912 16.6662 9.74197 16.6666 10.0036C16.6662 10.2652 16.5612 10.516 16.3762 10.7009C16.1913 10.8859 15.9412 10.99 15.6796 10.9904H10.9856V15.6825C10.9857 15.8121 10.9596 15.9404 10.9101 16.0601C10.8605 16.1799 10.7882 16.2888 10.6965 16.3805C10.6049 16.4721 10.496 16.5448 10.3762 16.5944C10.2565 16.644 10.1282 16.6694 9.99862 16.6693C9.86896 16.6694 9.7408 16.6437 9.62101 16.5941C9.50122 16.5445 9.39235 16.4719 9.3007 16.3802C9.20905 16.2884 9.13667 16.1796 9.08716 16.0598C9.03764 15.94 9.01146 15.8115 9.01164 15.6818Z",
    fill: "#4FB1EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/IconPlus.4499e710.svg";
export { ForwardRef as ReactComponent };